import { useInstance } from 'intact-vue';
import { useState } from '../../hooks/useState';
export function useDirty(getValidate) {
  var instance = useInstance();
  var isDirty = useState(false);
  if (instance.get('validateOnStart')) {
    dirty();
  }
  function onChange(e) {
    dirty();
    instance.trigger('change', e);
  }
  function onFocusout(e) {
    dirty();
    instance.trigger('focusout', e);
  }
  function dirty() {
    if (isDirty.value) return;
    isDirty.set(true);
    // for select, the focusout event triggers before select
    // so we put off validating it
    setTimeout(function () {
      // maybe it has been unmounted or reset
      if (instance.$unmounted || !isDirty.value) return;
      getValidate()();
    }, 100);
  }
  function reset() {
    isDirty.set(false);
  }
  return {
    onChange: onChange,
    onFocusout: onFocusout,
    isDirty: isDirty,
    reset: reset
  };
}